import { useState } from "react";
import { Row, Col, Drawer } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import i18n from "../../translation";
import Container from "../../common/Container";
import { Button } from "../../common/Button";
import {
  HeaderSection,
  LogoContainer,
  Burger,
  NotHidden,
  Menu,
  CustomNavLinkSmall,
  Label,
  Outline,
  Span,
  
} from "./styles";

const Header = ({ t }: { t: TFunction }) => {
  const [visible, setVisibility] = useState(false);

  const toggleButton = () => {
    setVisibility(!visible);
  };

  const MenuItem = () => {
    const scrollTo = (id: string) => {
      const element = document.getElementById(id) as HTMLDivElement;
      element.scrollIntoView({
        behavior: "smooth",
      });
      setVisibility(false);
    };
    return (
      <>
        <CustomNavLinkSmall onClick={() => scrollTo("about") }>
          <Span>{t("Our Services")}</Span>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall onClick={() => scrollTo("extra")}>
          <Span>{t("Jobs")}</Span>
        </CustomNavLinkSmall>

        <CustomNavLinkSmall
          onClick={() => scrollTo("contact")}
        >
          <Span>
            <Button >{t("Contact")}</Button>
          </Span>
        </CustomNavLinkSmall>
      </>
    );
  };

  return (
    <HeaderSection>
      <Container>
        <Row justify="space-between">
          <LogoContainer to="/" style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <img 
              src="/logoTransparent.png" 
              alt="Alea Felix Gambit Logo" 
              style={{ height: "65px", width: "auto" }}
            />
            <span style={{ 
              fontSize: "1.8rem", 
              fontWeight: 600, 
              color: "#18216d", 
              margin: 0 
            }}>{"Alea Felix Gambit"}</span>
          </LogoContainer>
          <NotHidden>
            <MenuItem />
          </NotHidden>
          <NotHidden style={{ display: "flex", alignItems: "center", gap: "8px", width:"200px"}}>
            <Button aria-label="Switch language to English" onClick={() => i18n.changeLanguage("en")} >
              EN
            </Button>
            <Button aria-label="Switch language to Croatian" onClick={() => i18n.changeLanguage("hr")} >
              HR
            </Button>
          </NotHidden>
          <Burger onClick={toggleButton}>
            <Outline />
          </Burger>
        </Row>
        <Drawer closable={false} open={visible} onClose={toggleButton}>
          <Col style={{ marginBottom: "2.5rem" }}>
            <Label onClick={toggleButton}>
              <Col span={12}>
                <Menu>Menu</Menu>
              </Col>
              <Col span={12}>
                <Outline />
              </Col>
            </Label>
          </Col>
          <MenuItem />
          <div style={{ display: "flex", gap: 8, marginTop: 16 }}>
            <CustomNavLinkSmall onClick={() => i18n.changeLanguage("en")}>
              <Span>
                <Button aria-label="Switch language to English" >EN</Button>
              </Span>
            </CustomNavLinkSmall>
            <CustomNavLinkSmall onClick={() => i18n.changeLanguage("hr")}>
              <Span>
                <Button aria-label="Switch language to Croatian" >HR</Button>
              </Span>
            </CustomNavLinkSmall>
          </div>
        </Drawer>
      </Container>
    </HeaderSection>
  );
};

export default withTranslation()(Header);
